import { useEffect } from "react";

export const SITE_URL = "https://greaterhopeservicedogs.org";
export const SITE_NAME = "Greater Hope Service Dogs";

interface SeoOptions {
  title: string;
  description: string;
  /** Canonical path for this page, e.g. "/about". */
  path: string;
  noindex?: boolean;
}

function setMetaTag(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(
    `meta[${attr}="${key}"]`,
  );
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setCanonical(url: string) {
  let el = document.head.querySelector<HTMLLinkElement>(
    'link[rel="canonical"]',
  );
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", url);
}

/**
 * Sets per-page SEO tags (title, description, canonical URL, Open Graph and
 * Twitter cards, robots directive). Google's crawler executes JavaScript, so
 * these client-side tags are picked up during indexing.
 */
export function useSeo({
  title,
  description,
  path,
  noindex = false,
}: SeoOptions) {
  useEffect(() => {
    const canonicalUrl = `${SITE_URL}${path === "/" ? "/" : path}`;

    document.title = title;
    setMetaTag("name", "description", description);
    setMetaTag(
      "name",
      "robots",
      noindex ? "noindex, nofollow" : "index, follow",
    );
    setMetaTag("property", "og:title", title);
    setMetaTag("property", "og:description", description);
    setMetaTag("property", "og:url", canonicalUrl);
    setMetaTag("name", "twitter:title", title);
    setMetaTag("name", "twitter:description", description);
    setCanonical(canonicalUrl);
  }, [title, description, path, noindex]);
}
